// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2RJyO","colCheckbox":"styles_colCheckbox__2LsXa"};